import React from 'react';
import { useState } from 'react';
import Banner from '../components/Banner';
import PracticeAreaModal from '../components/PracticeAreaModal';
import './Home.css'
import { Link } from 'react-router-dom';


import TestimonialCarousel from '../components/TestimonialCarousel';

const Casey = '/images/casey.png';

const testimonials: string[] = [
    "\"I couldn't be more impressed with the service I received. Casey was knowledgeable, thorough, and incredibly responsive throughout the entire process. He took the time to explain everything clearly, making sure I understood all my options before proceeding. I highly recommend Casey to anyone seeking reliable and effective legal representation.\"",
    "\"Casey is awesome. He is knowledgeable, quick to respond, patient with questions, and just a great guy. Highly recommend if you have a legal issue you’re experiencing. Would give more stars if I could!\"",
    "\"Mr Casey Daggett is the best legal attorney you would want to represent you. I called Casey regarding unfair practices from Aaron's and he was able to help me navigate through the best option. Casey is the person you are looking for. Do not hesitate to call as you will not be disappointed. Thanks Mr Daggett!\"",
    "\"Casey is as smart as they come and has a top-notch legal mind. Professional and responsive, yes, but also results-oriented. I've now worked with Casey for a few years and have referred people to him. Legal matter?  Casey is my first call!\"",
    "\"Very quick to respond to my inquiry and answered all legal questions in a timely manner. I even quite enjoyed the discourse from beginning to end.\"",
    "\"Helped me tremendously with my 2 cases and got me good settlements\"",
    "\"In a world where the weight of injustice can feel overwhelming there are moments when it truly feels like an angel touched one's life. Recently I witnessed a remarkable employment attorney who transformed an arduous battle into a journey of hope and empowerment.This man’s unwavering dedication and compassionate support for those facing workplace challenges were nothing short of miraculous. With every question answered and every strategy crafted it felt as though a guiding hand was at work ensuring that the truth would and shall prevail. 5 Star ⭐️ Attorney\"",
    "\"Casey was very helpful going line by line through my employment contract so that I was able to understand what I was signing. Very highly recommend.\"",
    "\"Consumer Equity was quick and fast with my legal issues! They were responsive with my questions and got my case taken care of in no time!\"",
    "\"I had an excellent experience with Consumer Equity Legal, especially working with Casey Daggett. Casey took an active, hands‑on role in my case and made it clear that he genuinely cared about me as a client. He is attentive, thorough, and consistently followed through — qualities that are often hard to find. Casey’s dedication really stood out. He made the process feel manageable and ensured I always understood what was happening and why. That level of personal investment made a huge difference. I highly recommend Consumer Equity Legal, and I’m especially grateful for Casey’s commitment and professionalism.\"",
    "\"Casey Daggett is AMAZING! In a time when people seem to always be taken advantage of and left feeling helpless, Casey is someone who really stands up for you and has your back. I was taken advantage of by Maaco, where they did a terrible job on my vehicle. During the process, I felt bullied and overwhelmed, but Casey stepped in and defended me. From my very first phone call with Casey, he made me feel like he genuinely cared about my situation, almost as if he were going through it himself. I am so grateful that I reached out to him. Casey Daggett is amazing. He is professional, compassionate, and truly fights for what is right. I am extremely happy with how everything turned out.\""
]

const practiceAreas = [
    {
        label: "Consumer Disputes",
        image: "/images/consumer.webp",
        link: "/practice-areas/consumer-disputes",
        description: "We help consumers fight against unfair business practices, fraudulent charges, and deceptive sales tactics. From unauthorized transactions to warranty disputes,\n we ensure your rights are protected."
    },
    {
        label: "Employment Law",
        image: "/images/employment.webp",
        link: "/practice-areas/employment-law",
        description: "We represent employees in cases of workplace harassment, discrimination, wrongful termination, wage theft, and retaliation. Your workplace rights matter, and we fight to protect them."
    },
    {
        label: "Business Litigation",
        image: "/images/business.webp",
        link: "/practice-areas/business-litigation",
        description: "We handle complex business disputes including breach of contract, partnership disputes, and commercial litigation. Our experienced team protects your business interests."
    },
    {
        label: "Unauthorized Transactions",
        image: "/images/debit.webp",
        link: "/practice-areas/unauthorized-debit",
        description: "If you have been charged for services you didn't authorize or subscriptions you can't cancel, we can pursue recovery of your funds and stop future unauthorized charges."
    },
    {
        label: "Breach of Contract",
        image: "/images/contract.webp",
        link: "/practice-areas/contract-disputes",
        description: "When contracts are broken, we help you understand your rights and pursue remedies. From service agreements to major business contracts, we protect your interests."
    },
    {
        label: "Privacy Law",
        image: "/images/privacy.webp",
        link: "/practice-areas/privacy",
        description: "We help clients navigate privacy violations, data breaches, and illegal surveillance. Your personal information deserves protection under the law."
    },
    {
        label: "Unfair Debt Collection",
        image: "/images/debt.jpeg",
        link: "/practice-areas/unfair-debt-collection",
        description: "We fight against unfair debt collection practices, including harassment and deceptive tactics. Let us help you reclaim your rights."
    },
    {
        label: "Civil Appeals",
        image: "/images/civil-appeals.webp",
        link: "/practice-areas/civil-appeals",
        description: "When trial court decisions need review, our appellate experience helps present your case effectively to higher courts for potential reversal or modification."
    },
];


function Home() {

    const [selectedPracticeArea, setSelectedPracticeArea] = useState<typeof practiceAreas[0] | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handlePracticeAreaClick = (area: typeof practiceAreas[0]) => {
        setSelectedPracticeArea(area);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedPracticeArea(null);
    };
    return (
        <div>
            <Banner />
            <section className="section about-section">
                <h2> About Us</h2>
                <p>
                    Consumer Equity Legal strives to obtain nothing less than excellent results for our clients.
                    The firm was built on the strong belief that every person should have someone on their side when 
                    battling deceptive and unfair business practices which are all too prevalent in the world today.
                    Whether the business is a financial institution, contractor, or retail giant,
                    <strong> we will gladly fight for you. </strong> 
                    <Link to="/client-intake">Contact us</Link> today to have us in your corner!
                </p>
                <Link to="/about" className="learn-more">Learn More</Link>
            </section>

            <section className="section testimonial-section">
                <h2>Client Testimonials</h2>
                <TestimonialCarousel testimonials={testimonials} />
            </section>

            <section className= "section practice-areas-section">
                <h2>Practice Areas</h2>
                <p>We specialize in a wide range of legal services. Fill out our <Link to="/client-intake">Client Intake Form</Link> so that we can assist you in any of our areas of expertise!</p>
                 <div className="practice-grid">
                    {practiceAreas.map((area, idx) => (
                        <button 
                            key={idx}
                            onClick={() => handlePracticeAreaClick(area)}
                            className="practice-grid-item practice-grid-button"
                        >
                            <div className="practice-grid-img-wrapper">
                                <img
                                    src={area.image}
                                    alt={area.label}
                                    className="practice-grid-img"
                                    loading="lazy"
                                    style={{ backgroundColor: '#f0f0f0' }} 
                                    decoding="async"
                                />
                                <div className="practice-grid-caption-overlay">{area.label}</div>
                            </div>
                        </button>
                    ))}
                </div>
            </section>

            <section className="section meet-the-team-section">
                <Link to={"/team"} className="section-link" aria-label="Meet The Team">
                    <h2>Meet The Team</h2>
                </Link>
                <h3>Our Lawyers Ensure Quality</h3>
                <Link to="/team/casey-daggett" className="image-link" aria-label="Learn more about Casey C. Daggett">
                    <img src={Casey} alt="Casey C. Daggett" className="team-member-photo"></img>
                    <p><strong>Casey C. Daggett</strong></p>
                    <p><em>Founder & Principal Attorney</em></p>
                </Link>
                <Link to="/team" className="learn-more">See Our Entire Team</Link>

            </section>

            <section className="section legal-assistance-section">
                <h2>Need Legal Assistance?</h2>
                <p>
                    Don't wait! If you're facing legal challenges, contact us today for a consultation.
                </p>
                <div className="newsletter-actions">
                    <Link to="/client-intake" className="cta-button primary">
                        Get Legal Help Now
                    </Link>
                </div>
            </section>

             {selectedPracticeArea && (
                <PracticeAreaModal
                    isOpen={isModalOpen}
                    onClose={closeModal}
                    title={selectedPracticeArea.label}
                    description={selectedPracticeArea.description}
                    image={selectedPracticeArea.image}
                />
            )}

        </div>
    );
}

export default Home;